(function () {
  function initPdpRedesign() {
    var root = document.querySelector('.pdp-redesign');

    if (!root) return;

    var anchorNav = root.querySelector('nav.anchor-nav');
    var anchorNavList = anchorNav && anchorNav.querySelector('ul');
    var anchorLinks = anchorNav ? Array.prototype.slice.call(anchorNav.querySelectorAll('a[href^="#"]')) : [];
    var anchorSections = anchorLinks.map(function (link) {
      return {
        link: link,
        section: document.querySelector(link.getAttribute('href'))
      };
    }).filter(function (item) {
      return item.section;
    });
    var activeAnchorLink = null;
    var anchorScrollScheduled = false;

    var updateActiveAnchor = function () {
      anchorScrollScheduled = false;
      if (!anchorNav || !anchorSections.length) return;

      var activationLine = anchorNav.getBoundingClientRect().bottom + 32;
      var activeItem = anchorSections[0];

      anchorSections.forEach(function (item) {
        if (item.section.getBoundingClientRect().top <= activationLine) activeItem = item;
      });

      if (activeItem.link === activeAnchorLink) return;

      anchorLinks.forEach(function (link) {
        var isActive = link === activeItem.link;
        link.classList.toggle('active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });

      activeAnchorLink = activeItem.link;

      if (anchorNavList && anchorNavList.scrollWidth > anchorNavList.clientWidth) {
        anchorNavList.scrollTo({
          left: activeAnchorLink.offsetLeft - (anchorNavList.clientWidth - activeAnchorLink.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    };

    var scheduleActiveAnchorUpdate = function () {
      if (anchorScrollScheduled) return;
      anchorScrollScheduled = true;
      window.requestAnimationFrame(updateActiveAnchor);
    };

    if (anchorNav && anchorSections.length) {
      updateActiveAnchor();
      window.addEventListener('scroll', scheduleActiveAnchorUpdate, { passive: true });
      window.addEventListener('resize', scheduleActiveAnchorUpdate);
      window.addEventListener('load', scheduleActiveAnchorUpdate);
    }

    var yotpoSection = root.querySelector('.pdp-customer-photos');

    var disablePinterestOnYotpoPhotos = function () {
      var yotpoWidget = yotpoSection && yotpoSection.querySelector('.yotpo-pictures-widget');

      if (!yotpoWidget) return;

      yotpoWidget.querySelectorAll('img').forEach(function (image) {
        image.classList.add('nopin');
        image.setAttribute('data-pin-nopin', 'true');
        image.setAttribute('data-pin-no-hover', 'true');
      });

    };

    if (yotpoSection) {
      disablePinterestOnYotpoPhotos();
      new MutationObserver(disablePinterestOnYotpoPhotos).observe(root, {
        childList: true,
        subtree: true
      });

      var yotpoPhotoSetupInterval = window.setInterval(disablePinterestOnYotpoPhotos, 500);
      window.setTimeout(function () {
        window.clearInterval(yotpoPhotoSetupInterval);
      }, 20000);

      var yotpoOpenButton = yotpoSection.querySelector('[data-pdp-yotpo-open]');
      var yotpoPopup = document.querySelector('.yotpo-custom-popup');
      var yotpoPopupClose = yotpoPopup && yotpoPopup.querySelector('.close-btn');
      var closeYotpoPopup = function () {
        if (!yotpoPopup) return;

        yotpoPopup.classList.remove('active');
        yotpoPopup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        if (yotpoOpenButton) yotpoOpenButton.focus();
      };

      if (yotpoOpenButton) {
        var yotpoSwipeStartX = 0;
        var yotpoDidSwipe = false;

        yotpoOpenButton.addEventListener('pointerdown', function (event) {
          yotpoSwipeStartX = event.clientX;
          yotpoDidSwipe = false;
        });

        yotpoOpenButton.addEventListener('pointerup', function (event) {
          var distance = event.clientX - yotpoSwipeStartX;

          if (Math.abs(distance) < 40) return;

          var arrowSelector = distance < 0 ? '.yotpo-icon-right-arrow-light' : '.yotpo-icon-left-arrow-light';
          var arrow = yotpoSection.querySelector(arrowSelector);
          yotpoDidSwipe = true;
          if (arrow) arrow.click();
        });

        yotpoOpenButton.addEventListener('click', function () {
          if (yotpoDidSwipe) {
            yotpoDidSwipe = false;
            return;
          }

          if (!yotpoPopup) return;

          yotpoPopup.classList.add('active');
          yotpoPopup.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
          if (yotpoPopupClose) yotpoPopupClose.focus();
        });
      }

      if (yotpoPopup && yotpoPopupClose) {
        yotpoPopupClose.addEventListener('click', closeYotpoPopup);
        yotpoPopup.addEventListener('click', function (event) {
          if (event.target === yotpoPopup) closeYotpoPopup();
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && yotpoPopup.classList.contains('active')) closeYotpoPopup();
        });
      }
    }

    var prop65OpenButton = root.querySelector('[data-pdp-prop65-open]');
    var prop65Modal = root.querySelector('[data-pdp-prop65-modal]');
    var prop65CloseButton = root.querySelector('[data-pdp-prop65-close]');

    var closeProp65Modal = function () {
      if (!prop65Modal || prop65Modal.hidden) return;

      prop65Modal.hidden = true;
      document.body.classList.remove('pdp-prop65-is-open');
      if (prop65OpenButton) prop65OpenButton.focus();
    };

    if (prop65OpenButton && prop65Modal && prop65CloseButton) {
      prop65OpenButton.addEventListener('click', function () {
        prop65Modal.hidden = false;
        document.body.classList.add('pdp-prop65-is-open');
        prop65CloseButton.focus();
      });

      prop65CloseButton.addEventListener('click', closeProp65Modal);
      prop65Modal.addEventListener('click', function (event) {
        if (event.target === prop65Modal) closeProp65Modal();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeProp65Modal();
      });
    }

    var reviewPreview = root.querySelector('[data-pdp-review-cards]');
    var yotpoReviewsWidget = root.querySelector('.pdp-reviews__widget .yotpo-widget-instance');

    var populateYotpoReviewPreview = function () {
      if (!reviewPreview || !yotpoReviewsWidget || reviewPreview.getAttribute('data-review-source') === 'yotpo') return false;

      var yotpoReviews = Array.prototype.slice.call(yotpoReviewsWidget.querySelectorAll('.yotpo-review-card'), 0, 4);

      if (!yotpoReviews.length) return false;

      var reviewCards = document.createDocumentFragment();

      yotpoReviews.forEach(function (review, reviewIndex) {
        var title = review.querySelector('.yotpo-review-title');
        var content = review.querySelector('.yotpo-review-content');
        var reviewer = review.querySelector('.yotpo-reviewer-name');
        var verified = review.querySelector('.yotpo-reviewer-verified-buyer-text');
        var date = review.querySelector('.yotpo-review-date');
        var ratingElement = review.querySelector('.yotpo-star-rating');
        var reviewImage = review.querySelector('img.yotpo-image');
        var ratingLabel = ratingElement ? ratingElement.getAttribute('aria-label') || '' : '';
        var ratingMatch = ratingLabel.match(/([0-5](?:\.\d)?) out of 5/i);
        var rating = ratingMatch ? Math.round(parseFloat(ratingMatch[1])) : 5;
        var card = document.createElement('article');
        var cardContent = document.createElement('div');
        var stars = document.createElement('span');
        var cardTitle = document.createElement('strong');
        var cardCopy = document.createElement('p');
        var cardMeta = document.createElement('small');
        var reviewerName = reviewer ? reviewer.textContent.trim() : 'Deco TV Frames customer';

        card.className = 'pdp-review-card';
        card.tabIndex = 0;
        card.setAttribute('role', 'button');
        card.setAttribute('aria-haspopup', 'dialog');
        card.setAttribute('data-yotpo-review-index', reviewIndex);

        if (reviewImage) {
          var imageSource = reviewImage.getAttribute('srcset') || reviewImage.getAttribute('src') || reviewImage.getAttribute('data-src');

          if (imageSource) {
            var cardImage = document.createElement('img');
            var firstImageSource = imageSource.split(',')[0].trim().split(' ')[0];

            card.classList.add('pdp-review-card--has-image');
            cardImage.loading = 'lazy';
            cardImage.src = firstImageSource;
            cardImage.srcset = imageSource;
            cardImage.sizes = 'auto';
            cardImage.width = parseInt(reviewImage.getAttribute('width'), 10) || 520;
            cardImage.height = parseInt(reviewImage.getAttribute('height'), 10) || 520;
            cardImage.alt = (title ? title.textContent.trim() : 'Customer review') + ' photo from ' + reviewerName;
            card.appendChild(cardImage);
          }
        }

        stars.className = 'pdp-review-card__stars';
        stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
        stars.setAttribute('aria-label', ratingLabel || rating + ' out of 5 stars');
        cardTitle.textContent = title ? title.textContent.trim() : 'Customer review';
        card.setAttribute('aria-label', 'Open full Yotpo review: ' + cardTitle.textContent);
        cardCopy.textContent = content ? content.textContent.trim().replace(/\s*Read more\s*$/i, '') : '';
        cardMeta.textContent = reviewerName;
        if (verified && verified.textContent.trim()) cardMeta.textContent += ' · ' + verified.textContent.trim();
        if (date && date.textContent.trim()) cardMeta.textContent += ' · ' + date.textContent.trim().replace(/^Published date/i, '');

        cardContent.appendChild(stars);
        cardContent.appendChild(cardTitle);
        cardContent.appendChild(cardCopy);
        cardContent.appendChild(cardMeta);
        card.appendChild(cardContent);
        reviewCards.appendChild(card);
      });

      reviewPreview.replaceChildren(reviewCards);
      reviewPreview.setAttribute('aria-busy', 'false');
      reviewPreview.setAttribute('data-review-source', 'yotpo');
      return true;
    };

    if (reviewPreview && yotpoReviewsWidget && !populateYotpoReviewPreview()) {
      var yotpoReviewObserver = new MutationObserver(function () {
        if (populateYotpoReviewPreview()) yotpoReviewObserver.disconnect();
      });

      yotpoReviewObserver.observe(yotpoReviewsWidget, { childList: true, subtree: true });
    }

    var openYotpoReview = function (previewCard) {
      if (!previewCard || !yotpoReviewsWidget) return;

      var reviewIndex = parseInt(previewCard.getAttribute('data-yotpo-review-index'), 10);
      var sourceReview = yotpoReviewsWidget.querySelectorAll('.yotpo-review-card')[reviewIndex];
      var mediaButton = sourceReview && sourceReview.querySelector('.yotpo-media-button');
      var fullReviews = root.querySelector('.pdp-reviews__widget');

      if (mediaButton) {
        if (fullReviews) fullReviews.open = true;
        window.requestAnimationFrame(function () {
          mediaButton.click();
        });
        return;
      }

      if (!sourceReview || !fullReviews) return;

      fullReviews.open = true;
      window.requestAnimationFrame(function () {
        sourceReview.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    };

    if (reviewPreview) {
      reviewPreview.addEventListener('click', function (event) {
        openYotpoReview(event.target.closest('.pdp-review-card[data-yotpo-review-index]'));
      });

      reviewPreview.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        var previewCard = event.target.closest('.pdp-review-card[data-yotpo-review-index]');
        if (!previewCard) return;

        event.preventDefault();
        openYotpoReview(previewCard);
      });
    }

    var fitRows = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-fit-row]'));
    var largestFitSize = fitRows.reduce(function (largest, row) {
      return Math.max(largest, parseFloat(row.getAttribute('data-pdp-fit-row')) || 0);
    }, 0);
    var fitSizes = fitRows.reduce(function (sizes, row) {
      var size = row.getAttribute('data-pdp-fit-row').replace(/[^\d.]/g, '');
      var previewWidth = parseFloat(row.getAttribute('data-pdp-fit-preview-width'));

      if (!previewWidth && largestFitSize) {
        previewWidth = Math.max(32, Math.min(96, (parseFloat(size) / largestFitSize) * 96));
      }

      sizes[size] = {
        width: row.getAttribute('data-pdp-fit-width'),
        height: row.getAttribute('data-pdp-fit-height'),
        previewWidth: previewWidth || 50
      };
      return sizes;
    }, {});

    var updateFitCalculator = function (value) {
      var normalizedSize = value.replace(/[^\d.]/g, '');
      var fit = fitSizes[normalizedSize];
      var screen = root.querySelector('.pdp-fit__screen');
      var sizeLabel = root.querySelector('[data-pdp-fit-size]');
      var widthLabel = root.querySelector('[data-pdp-fit-width]');
      var heightLabel = root.querySelector('[data-pdp-fit-height]');

      if (!fit || !screen) return;

      screen.style.setProperty('--pdp-fit-screen-width', fit.previewWidth + '%');
      if (sizeLabel) sizeLabel.textContent = value.replace('"', '″');
      if (widthLabel) widthLabel.textContent = fit.width;
      if (heightLabel) heightLabel.textContent = fit.height;

      root.querySelectorAll('[data-pdp-size]').forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-pdp-size') === value);
      });

      root.querySelectorAll('[data-pdp-fit-row]').forEach(function (row) {
        var rowSize = row.getAttribute('data-pdp-fit-row').replace(/[^\d.]/g, '');
        row.classList.toggle('is-active', rowSize === normalizedSize);
      });
    };

    root.querySelectorAll('[data-pdp-size]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-pdp-size');
        var choices = root.querySelectorAll('.swatch_options input, .swatch_options label, select option');

        choices.forEach(function (choice) {
          var choiceValue = choice.value || choice.textContent.trim();

          if (choiceValue === value || choiceValue.indexOf(value) === 0) {
            if (choice.tagName === 'OPTION') {
              choice.parentElement.value = choice.value;
              choice.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              choice.click();
            }
          }
        });

        updateFitCalculator(value);
      });
    });

    var addToCart = root.querySelector('#AddToCart');
    var proxyCartButtons = root.querySelectorAll('[data-pdp-add-to-cart]');
    var mobileCart = document.querySelector('[data-pdp-mobile-cart]');
    var mobileCartUpdateScheduled = false;

    var updateMobileCartVisibility = function () {
      mobileCartUpdateScheduled = false;

      if (!addToCart || !mobileCart) return;

      var hasScrolledPastAddToCart = addToCart.getBoundingClientRect().bottom < 0;
      mobileCart.classList.toggle('is-visible', hasScrolledPastAddToCart);
      mobileCart.setAttribute('aria-hidden', hasScrolledPastAddToCart ? 'false' : 'true');
    };

    var scheduleMobileCartVisibilityUpdate = function () {
      if (mobileCartUpdateScheduled) return;
      mobileCartUpdateScheduled = true;
      window.requestAnimationFrame(updateMobileCartVisibility);
    };

    if (addToCart && mobileCart) {
      updateMobileCartVisibility();
      window.addEventListener('scroll', scheduleMobileCartVisibilityUpdate, { passive: true });
      window.addEventListener('resize', scheduleMobileCartVisibilityUpdate);
    }

    var syncProxyCartButtons = function () {
      if (!addToCart) return;

      proxyCartButtons.forEach(function (button) {
        button.disabled = addToCart.disabled;
        button.classList.toggle('is-loading', addToCart.disabled);
        button.setAttribute('aria-busy', addToCart.disabled ? 'true' : 'false');
      });

      syncAddToCartPriceLabel();
    };

    var getAddToCartLabel = function () {
      if (!addToCart) return 'Add to Cart';

      var label = addToCart.getAttribute('data-label');

      if (!label) return 'Add to Cart';

      try {
        return JSON.parse(label);
      } catch (error) {
        return label;
      }
    };

    var syncAddToCartPriceLabel = function () {
      if (!addToCart) return;

      var textEl = addToCart.querySelector('span.text');

      if (!textEl) return;

      // Leave sold-out / unavailable messaging alone.
      if (addToCart.disabled || addToCart.classList.contains('disabled')) return;

      var price = root.querySelector('.current_price .money');
      var priceText = price ? price.textContent.trim() : '';
      var label = getAddToCartLabel();
      var desiredText = priceText ? label + ' · ' + priceText : label;

      // Theme variant JS resets this to the bare label; rebuild with a price node
      // that CSS can show only on mobile.
      if (textEl.textContent.trim() === desiredText && (!priceText || textEl.querySelector('.pdp-atc-price'))) {
        return;
      }

      textEl.textContent = '';
      textEl.appendChild(document.createTextNode(priceText ? label + ' ' : label));

      if (priceText) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'pdp-atc-price';
        priceSpan.textContent = '· ' + priceText;
        textEl.appendChild(priceSpan);
      }
    };

    proxyCartButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        if (!addToCart || addToCart.disabled) return;

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        if (window.jQuery) {
          window.jQuery(addToCart).trigger('click');
        } else {
          addToCart.click();
        }
      });
    });

    if (addToCart) {
      syncProxyCartButtons();
      new MutationObserver(syncProxyCartButtons).observe(addToCart, {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });

      var addToCartText = addToCart.querySelector('span.text');
      if (addToCartText) {
        // Theme variant JS resets the button label; re-apply the mobile price after that.
        new MutationObserver(function () {
          window.requestAnimationFrame(syncAddToCartPriceLabel);
        }).observe(addToCartText, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      window.addEventListener('resize', syncAddToCartPriceLabel);
      // Variant/option scripts can finish after first paint; re-apply a few times.
      window.setTimeout(syncAddToCartPriceLabel, 0);
      window.setTimeout(syncAddToCartPriceLabel, 250);
      window.setTimeout(syncAddToCartPriceLabel, 1000);
    }

    var modelButton = root.querySelector('[data-pdp-model-check]');
    var modelInput = root.querySelector('[data-pdp-model-input]');
    var modelResult = root.querySelector('[data-pdp-model-result]');

    if (modelButton && modelInput && modelResult) {
      modelButton.addEventListener('click', function () {
        var value = modelInput.value.trim().toUpperCase();
        var isLegacyModel = /LS(?:[0O]3[TRN]|[0O]{2}3)/.test(value);

        if (isLegacyModel) {
          window.location.assign('/collections/legacy-frames');
          return;
        }

        var isCompatible = /LS[0O]3/.test(value);
        modelResult.textContent = isCompatible
          ? '✓ This model is compatible. Match the screen size and model year above.'
          : 'We could not confirm this model. Look for LS03 in the full model number.';
        modelResult.classList.toggle('is-compatible', isCompatible);
      });
    }

    var installSteps = root.querySelectorAll('.pdp-install__step');

    installSteps.forEach(function (step) {
      step.addEventListener('toggle', function () {
        if (!step.open) return;

        installSteps.forEach(function (otherStep) {
          if (otherStep !== step) otherStep.open = false;
        });
      });
    });

    var videoOpenButton = root.querySelector('[data-pdp-video-open]');
    var videoModal = root.querySelector('[data-pdp-video-modal]');
    var videoCloseButton = root.querySelector('[data-pdp-video-close]');
    var videoIframe = videoModal ? videoModal.querySelector('iframe') : null;
    var installationVideo = videoModal ? videoModal.querySelector('video') : null;

    var closeVideo = function () {
      if (!videoModal || videoModal.hidden) return;

      videoModal.hidden = true;
      document.body.classList.remove('pdp-video-is-open');

      if (videoIframe) {
        videoIframe.src = 'about:blank';
      }
      if (installationVideo) {
        installationVideo.pause();
        installationVideo.currentTime = 0;
      }

      if (videoOpenButton) videoOpenButton.focus();
    };

    if (videoOpenButton && videoModal && videoCloseButton) {
      videoOpenButton.addEventListener('click', function () {
        var videoSrc = videoIframe ? videoIframe.getAttribute('data-src') : '';

        if (videoIframe && videoSrc) videoIframe.src = videoSrc;
        videoModal.hidden = false;
        if (installationVideo) {
          var playRequest = installationVideo.play();
          if (playRequest) playRequest.catch(function () {});
        }
        document.body.classList.add('pdp-video-is-open');
        videoCloseButton.focus();
      });

      videoCloseButton.addEventListener('click', closeVideo);
      videoModal.addEventListener('click', function (event) {
        if (event.target === videoModal) closeVideo();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeVideo();
      });
    }

    var updatePrice = function () {
      var price = root.querySelector('.current_price .money');

      if (!price) return;

      var priceText = price.textContent.trim();
      root.querySelectorAll('.pdp-mobile-cart__price, [data-pdp-nav-price]').forEach(function (target) {
        target.textContent = priceText;
      });

      syncAddToCartPriceLabel();
    };

    var priceContainer = root.querySelector('.modal_price') || root.querySelector('.product_form');
    var priceRow = root.querySelector('.pdp-price-row');
    var productForm = root.querySelector('[data-product-form]') || root.querySelector('.product_form form');
    var paymentTerms = null;

    var updatePaymentTerms = function () {
      var variantInput = productForm && productForm.querySelector('[name="id"]');

      if (paymentTerms && variantInput && variantInput.value) {
        paymentTerms.setAttribute('variant-id', variantInput.value);
      }
    };

    var placePaymentTermsByPrice = function () {
      var currentPaymentTerms = root.querySelector('shopify-payment-terms');

      if (!priceRow || !currentPaymentTerms) return false;

      paymentTerms = currentPaymentTerms;
      if (paymentTerms.parentElement !== priceRow) priceRow.appendChild(paymentTerms);
      updatePaymentTerms();
      return true;
    };

    placePaymentTermsByPrice();

    // Shopify can insert or replace the financing element after initial render.
    // Watch its original form host so it is consistently returned to the price row.
    if (productForm) {
      new MutationObserver(placePaymentTermsByPrice).observe(productForm, {
        childList: true,
        subtree: true
      });
    }

    updatePrice();

    if (priceContainer) {
      new MutationObserver(updatePrice).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (productForm) {
      productForm.addEventListener('change', function () {
        var selectedFitSize = root.querySelector('.swatch_options input:checked');

        if (selectedFitSize) updateFitCalculator(selectedFitSize.value);
        window.requestAnimationFrame(updatePrice);
        window.requestAnimationFrame(updatePaymentTerms);
        window.setTimeout(updatePrice, 100);
        window.setTimeout(updatePrice, 300);
        window.setTimeout(updatePaymentTerms, 100);
      });
    }

    var selectedSize = root.querySelector('.swatch_options input:checked');
    if (selectedSize) {
      updateFitCalculator(selectedSize.value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpRedesign);
  } else {
    initPdpRedesign();
  }
})();
